import { Card } from 'antd';
import Container from '../../components/Container';
import UserOrderTable from '../../components/users/userDetail/UserOrderTable';

const OrderList = () => {
  return (
    <Container>
      <Card>
        <UserOrderTable />
      </Card>
    </Container>
  );
};

export default OrderList;
